//////////////////////////////////////////////////////////////////////////////////////////////
// DO NOT MODIFY THIS FILE                                                                  //
// This file is automatically generated by ZenStack CLI and should not be manually updated. //
//////////////////////////////////////////////////////////////////////////////////////////////

/* eslint-disable */

import { type SchemaDef, type AttributeApplication, type FieldDefault, ExpressionUtils } from "@zenstackhq/schema";
export class SchemaType implements SchemaDef {
    provider = {
        type: "postgresql"
    } as const;
    models = {
        User: {
            name: "User",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                email: {
                    name: "email",
                    type: "String",
                    unique: true
                },
                password: {
                    name: "password",
                    type: "String",
                    omit: true
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                },
                role: {
                    name: "role",
                    type: "Role",
                    default: "USER" as FieldDefault
                },
                approved: {
                    name: "approved",
                    type: "Boolean",
                    default: false as FieldDefault
                },
                notificationsEnabled: {
                    name: "notificationsEnabled",
                    type: "Boolean",
                    default: true as FieldDefault
                },
                notificationsSeenAt: {
                    name: "notificationsSeenAt",
                    type: "DateTime",
                    optional: true
                },
                deactivatedAt: {
                    name: "deactivatedAt",
                    type: "DateTime",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                },
                specialist: {
                    name: "specialist",
                    type: "Specialist",
                    optional: true,
                    relation: { opposite: "user" }
                },
                invitesSent: {
                    name: "invitesSent",
                    type: "Invite",
                    array: true,
                    relation: { opposite: "invitedBy", name: "invitedBy" }
                },
                authoredNotes: {
                    name: "authoredNotes",
                    type: "Note",
                    array: true,
                    relation: { opposite: "author" }
                },
                createdGroupEvents: {
                    name: "createdGroupEvents",
                    type: "GroupEvent",
                    array: true,
                    relation: { opposite: "createdBy", name: "GroupEventCreator" }
                },
                groupEventMemberships: {
                    name: "groupEventMemberships",
                    type: "GroupEventMember",
                    array: true,
                    relation: { opposite: "user" }
                },
                assignedEnrollments: {
                    name: "assignedEnrollments",
                    type: "GroupEventEnrollment",
                    array: true,
                    relation: { opposite: "assignedUser", name: "EnrollmentAssignee" }
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                email: { type: "String" }
            }
        },
        Specialty: {
            name: "Specialty",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                slug: {
                    name: "slug",
                    type: "String",
                    unique: true
                },
                name: {
                    name: "name",
                    type: "Json"
                },
                aliases: {
                    name: "aliases",
                    type: "String",
                    array: true,
                    default: [] as FieldDefault
                },
                active: {
                    name: "active",
                    type: "Boolean",
                    default: true as FieldDefault
                },
                specialists: {
                    name: "specialists",
                    type: "Specialist",
                    array: true,
                    relation: { opposite: "specialties" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                slug: { type: "String" }
            }
        },
        Service: {
            name: "Service",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                slug: {
                    name: "slug",
                    type: "String",
                    unique: true
                },
                name: {
                    name: "name",
                    type: "Json"
                },
                aliases: {
                    name: "aliases",
                    type: "String",
                    array: true,
                    default: [] as FieldDefault
                },
                color: {
                    name: "color",
                    type: "String",
                    optional: true
                },
                active: {
                    name: "active",
                    type: "Boolean",
                    default: true as FieldDefault
                },
                enrollments: {
                    name: "enrollments",
                    type: "GroupEventEnrollment",
                    array: true,
                    relation: { opposite: "service" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                slug: { type: "String" }
            }
        },
        ClinicSettings: {
            name: "ClinicSettings",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: "singleton" as FieldDefault
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                },
                logo: {
                    name: "logo",
                    type: "String",
                    optional: true
                },
                phone: {
                    name: "phone",
                    type: "String",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        Specialist: {
            name: "Specialist",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                userId: {
                    name: "userId",
                    type: "String",
                    unique: true,
                    foreignKeyFor: [
                        "user"
                    ] as readonly string[]
                },
                user: {
                    name: "user",
                    type: "User",
                    relation: { opposite: "specialist", fields: ["userId"], references: ["id"], onDelete: "Cascade" }
                },
                displayName: {
                    name: "displayName",
                    type: "Json",
                    optional: true
                },
                title: {
                    name: "title",
                    type: "Json",
                    optional: true
                },
                bio: {
                    name: "bio",
                    type: "Json",
                    optional: true
                },
                phone: {
                    name: "phone",
                    type: "String",
                    optional: true
                },
                active: {
                    name: "active",
                    type: "Boolean",
                    default: true as FieldDefault
                },
                specialties: {
                    name: "specialties",
                    type: "Specialty",
                    array: true,
                    relation: { opposite: "specialists" }
                },
                availabilitySources: {
                    name: "availabilitySources",
                    type: "AvailabilitySource",
                    array: true,
                    relation: { opposite: "specialist" }
                },
                healeeConnection: {
                    name: "healeeConnection",
                    type: "HealeeConnection",
                    optional: true,
                    relation: { opposite: "specialist" }
                },
                appointments: {
                    name: "appointments",
                    type: "Appointment",
                    array: true,
                    relation: { opposite: "specialist" }
                },
                calls: {
                    name: "calls",
                    type: "Call",
                    array: true,
                    relation: { opposite: "specialist" }
                },
                assignedContacts: {
                    name: "assignedContacts",
                    type: "Contact",
                    array: true,
                    relation: { opposite: "assignedSpecialists" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                userId: { type: "String" }
            }
        },
        AvailabilitySource: {
            name: "AvailabilitySource",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                specialistId: {
                    name: "specialistId",
                    type: "String",
                    foreignKeyFor: [
                        "specialist"
                    ] as readonly string[]
                },
                specialist: {
                    name: "specialist",
                    type: "Specialist",
                    relation: { opposite: "availabilitySources", fields: ["specialistId"], references: ["id"], onDelete: "Cascade" }
                },
                provider: {
                    name: "provider",
                    type: "AvailabilityProvider"
                },
                config: {
                    name: "config",
                    type: "Json"
                },
                eventId: {
                    name: "eventId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "event"
                    ] as readonly string[]
                },
                event: {
                    name: "event",
                    type: "GroupEvent",
                    optional: true,
                    relation: { opposite: "availabilitySources", name: "GroupEventSources", fields: ["eventId"], references: ["id"], onDelete: "SetNull" }
                },
                active: {
                    name: "active",
                    type: "Boolean",
                    default: true as FieldDefault
                },
                priority: {
                    name: "priority",
                    type: "Int",
                    default: 0 as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                specialistId_provider: { specialistId: { type: "String" }, provider: { type: "AvailabilityProvider" } }
            }
        },
        HealeeConnection: {
            name: "HealeeConnection",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                specialistId: {
                    name: "specialistId",
                    type: "String",
                    unique: true,
                    foreignKeyFor: [
                        "specialist"
                    ] as readonly string[]
                },
                specialist: {
                    name: "specialist",
                    type: "Specialist",
                    relation: { opposite: "healeeConnection", fields: ["specialistId"], references: ["id"], onDelete: "Cascade" }
                },
                calendarId: {
                    name: "calendarId",
                    type: "Int"
                },
                settings: {
                    name: "settings",
                    type: "Json",
                    optional: true
                },
                active: {
                    name: "active",
                    type: "Boolean",
                    default: true as FieldDefault
                },
                connectedAt: {
                    name: "connectedAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                specialistId: { type: "String" }
            }
        },
        Appointment: {
            name: "Appointment",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                specialistId: {
                    name: "specialistId",
                    type: "String",
                    foreignKeyFor: [
                        "specialist"
                    ] as readonly string[]
                },
                specialist: {
                    name: "specialist",
                    type: "Specialist",
                    relation: { opposite: "appointments", fields: ["specialistId"], references: ["id"], onDelete: "Cascade" }
                },
                patientName: {
                    name: "patientName",
                    type: "String"
                },
                patientPhone: {
                    name: "patientPhone",
                    type: "String"
                },
                reason: {
                    name: "reason",
                    type: "String",
                    optional: true
                },
                extraPatients: {
                    name: "extraPatients",
                    type: "Json",
                    optional: true
                },
                startsAt: {
                    name: "startsAt",
                    type: "DateTime"
                },
                endsAt: {
                    name: "endsAt",
                    type: "DateTime"
                },
                googleEventId: {
                    name: "googleEventId",
                    type: "String",
                    optional: true
                },
                healeeAppointmentId: {
                    name: "healeeAppointmentId",
                    type: "Int",
                    unique: true,
                    optional: true
                },
                conversationId: {
                    name: "conversationId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "call"
                    ] as readonly string[]
                },
                call: {
                    name: "call",
                    type: "Call",
                    optional: true,
                    relation: { opposite: "appointments", fields: ["conversationId"], references: ["conversationId"], onDelete: "SetNull" }
                },
                contactId: {
                    name: "contactId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "contact"
                    ] as readonly string[]
                },
                contact: {
                    name: "contact",
                    type: "Contact",
                    optional: true,
                    relation: { opposite: "appointments", fields: ["contactId"], references: ["id"], onDelete: "SetNull" }
                },
                notes: {
                    name: "notes",
                    type: "Note",
                    array: true,
                    relation: { opposite: "appointment" }
                },
                status: {
                    name: "status",
                    type: "AppointmentStatus",
                    default: "BOOKED" as FieldDefault
                },
                rescheduled: {
                    name: "rescheduled",
                    type: "Boolean",
                    default: false as FieldDefault
                },
                calendarDesynced: {
                    name: "calendarDesynced",
                    type: "Boolean",
                    default: false as FieldDefault
                },
                source: {
                    name: "source",
                    type: "String",
                    default: "voice" as FieldDefault
                },
                slotSeq: {
                    name: "slotSeq",
                    type: "Int",
                    default: 0 as FieldDefault
                },
                healee: {
                    name: "healee",
                    type: "AppointmentHealee",
                    optional: true,
                    relation: { opposite: "appointment" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                healeeAppointmentId: { type: "Int" }
            }
        },
        AppointmentHealee: {
            name: "AppointmentHealee",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                appointmentId: {
                    name: "appointmentId",
                    type: "String",
                    unique: true,
                    foreignKeyFor: [
                        "appointment"
                    ] as readonly string[]
                },
                appointment: {
                    name: "appointment",
                    type: "Appointment",
                    relation: { opposite: "healee", fields: ["appointmentId"], references: ["id"], onDelete: "Cascade" }
                },
                patientAge: {
                    name: "patientAge",
                    type: "Int",
                    optional: true
                },
                patientNote: {
                    name: "patientNote",
                    type: "String",
                    optional: true
                },
                isVideo: {
                    name: "isVideo",
                    type: "Boolean",
                    default: false as FieldDefault
                },
                bookedOnline: {
                    name: "bookedOnline",
                    type: "Boolean",
                    optional: true
                },
                paymentMethodName: {
                    name: "paymentMethodName",
                    type: "String",
                    optional: true
                },
                insurerName: {
                    name: "insurerName",
                    type: "String",
                    optional: true
                },
                insurerStatus: {
                    name: "insurerStatus",
                    type: "String",
                    optional: true
                },
                meta: {
                    name: "meta",
                    type: "Json",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                appointmentId: { type: "String" }
            }
        },
        Call: {
            name: "Call",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                conversationId: {
                    name: "conversationId",
                    type: "String",
                    unique: true,
                    optional: true
                },
                specialistId: {
                    name: "specialistId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "specialist"
                    ] as readonly string[]
                },
                specialist: {
                    name: "specialist",
                    type: "Specialist",
                    optional: true,
                    relation: { opposite: "calls", fields: ["specialistId"], references: ["id"], onDelete: "SetNull" }
                },
                booked: {
                    name: "booked",
                    type: "Boolean",
                    default: false as FieldDefault
                },
                bookingAction: {
                    name: "bookingAction",
                    type: "CallBookingAction",
                    optional: true
                },
                bookingLabel: {
                    name: "bookingLabel",
                    type: "String",
                    optional: true
                },
                callerName: {
                    name: "callerName",
                    type: "String",
                    optional: true
                },
                callerPhone: {
                    name: "callerPhone",
                    type: "String",
                    optional: true
                },
                contactId: {
                    name: "contactId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "contact"
                    ] as readonly string[]
                },
                contact: {
                    name: "contact",
                    type: "Contact",
                    optional: true,
                    relation: { opposite: "calls", fields: ["contactId"], references: ["id"], onDelete: "SetNull" }
                },
                assistantId: {
                    name: "assistantId",
                    type: "String",
                    optional: true
                },
                startedAt: {
                    name: "startedAt",
                    type: "DateTime",
                    optional: true
                },
                endedAt: {
                    name: "endedAt",
                    type: "DateTime",
                    optional: true
                },
                endedReason: {
                    name: "endedReason",
                    type: "String",
                    optional: true
                },
                durationSec: {
                    name: "durationSec",
                    type: "Int",
                    optional: true
                },
                cost: {
                    name: "cost",
                    type: "Float",
                    optional: true
                },
                summary: {
                    name: "summary",
                    type: "String",
                    optional: true
                },
                transcript: {
                    name: "transcript",
                    type: "CallTranscript",
                    optional: true,
                    relation: { opposite: "call" }
                },
                appointments: {
                    name: "appointments",
                    type: "Appointment",
                    array: true,
                    relation: { opposite: "call" }
                },
                groupEnrollments: {
                    name: "groupEnrollments",
                    type: "GroupEventEnrollment",
                    array: true,
                    relation: { opposite: "call", name: "CallEnrollments" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                conversationId: { type: "String" }
            }
        },
        CallTranscript: {
            name: "CallTranscript",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                callId: {
                    name: "callId",
                    type: "String",
                    unique: true,
                    foreignKeyFor: [
                        "call"
                    ] as readonly string[]
                },
                call: {
                    name: "call",
                    type: "Call",
                    relation: { opposite: "transcript", fields: ["callId"], references: ["id"], onDelete: "Cascade" }
                },
                text: {
                    name: "text",
                    type: "String",
                    optional: true
                },
                messages: {
                    name: "messages",
                    type: "Json",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                callId: { type: "String" }
            }
        },
        ActivityEvent: {
            name: "ActivityEvent",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                action: {
                    name: "action",
                    type: "ActivityAction"
                },
                platform: {
                    name: "platform",
                    type: "ActivityPlatform"
                },
                domain: {
                    name: "domain",
                    type: "String",
                    default: "calendar" as FieldDefault
                },
                actorUserId: {
                    name: "actorUserId",
                    type: "String",
                    optional: true
                },
                actorName: {
                    name: "actorName",
                    type: "String",
                    optional: true
                },
                appointmentId: {
                    name: "appointmentId",
                    type: "String",
                    optional: true
                },
                enrollmentId: {
                    name: "enrollmentId",
                    type: "String",
                    optional: true
                },
                specialistId: {
                    name: "specialistId",
                    type: "String",
                    optional: true
                },
                contactId: {
                    name: "contactId",
                    type: "String",
                    optional: true
                },
                conversationId: {
                    name: "conversationId",
                    type: "String",
                    optional: true
                },
                externalRef: {
                    name: "externalRef",
                    type: "String",
                    optional: true
                },
                doctorName: {
                    name: "doctorName",
                    type: "String",
                    optional: true
                },
                patientName: {
                    name: "patientName",
                    type: "String",
                    optional: true
                },
                patientPhone: {
                    name: "patientPhone",
                    type: "String",
                    optional: true
                },
                whenText: {
                    name: "whenText",
                    type: "String",
                    optional: true
                },
                oldWhenText: {
                    name: "oldWhenText",
                    type: "String",
                    optional: true
                },
                reason: {
                    name: "reason",
                    type: "String",
                    optional: true
                },
                note: {
                    name: "note",
                    type: "String",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        Contact: {
            name: "Contact",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                name: {
                    name: "name",
                    type: "String"
                },
                phone: {
                    name: "phone",
                    type: "String"
                },
                altPhones: {
                    name: "altPhones",
                    type: "String",
                    array: true,
                    default: [] as FieldDefault
                },
                status: {
                    name: "status",
                    type: "ContactStatus",
                    default: "LEAD" as FieldDefault
                },
                flags: {
                    name: "flags",
                    type: "String",
                    array: true,
                    default: [] as FieldDefault
                },
                assignedSpecialists: {
                    name: "assignedSpecialists",
                    type: "Specialist",
                    array: true,
                    relation: { opposite: "assignedContacts" }
                },
                notes: {
                    name: "notes",
                    type: "Note",
                    array: true,
                    relation: { opposite: "contact" }
                },
                calls: {
                    name: "calls",
                    type: "Call",
                    array: true,
                    relation: { opposite: "contact" }
                },
                appointments: {
                    name: "appointments",
                    type: "Appointment",
                    array: true,
                    relation: { opposite: "contact" }
                },
                groupEnrollments: {
                    name: "groupEnrollments",
                    type: "GroupEventEnrollment",
                    array: true,
                    relation: { opposite: "contact", name: "ContactEnrollments" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                name_phone: { name: { type: "String" }, phone: { type: "String" } }
            }
        },
        Note: {
            name: "Note",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                contactId: {
                    name: "contactId",
                    type: "String",
                    foreignKeyFor: [
                        "contact"
                    ] as readonly string[]
                },
                contact: {
                    name: "contact",
                    type: "Contact",
                    relation: { opposite: "notes", fields: ["contactId"], references: ["id"], onDelete: "Cascade" }
                },
                appointmentId: {
                    name: "appointmentId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "appointment"
                    ] as readonly string[]
                },
                appointment: {
                    name: "appointment",
                    type: "Appointment",
                    optional: true,
                    relation: { opposite: "notes", fields: ["appointmentId"], references: ["id"], onDelete: "Cascade" }
                },
                body: {
                    name: "body",
                    type: "String"
                },
                authorId: {
                    name: "authorId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "author"
                    ] as readonly string[]
                },
                author: {
                    name: "author",
                    type: "User",
                    optional: true,
                    relation: { opposite: "authoredNotes", fields: ["authorId"], references: ["id"], onDelete: "SetNull" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        Voice: {
            name: "Voice",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                label: {
                    name: "label",
                    type: "String"
                },
                voiceId: {
                    name: "voiceId",
                    type: "String",
                    unique: true
                },
                language: {
                    name: "language",
                    type: "String",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                voiceId: { type: "String" }
            }
        },
        VoiceAgent: {
            name: "VoiceAgent",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                name: {
                    name: "name",
                    type: "String"
                },
                kind: {
                    name: "kind",
                    type: "String",
                    default: "assistant" as FieldDefault
                },
                externalAgentId: {
                    name: "externalAgentId",
                    type: "String",
                    unique: true,
                    optional: true
                },
                systemPrompt: {
                    name: "systemPrompt",
                    type: "String",
                    optional: true
                },
                config: {
                    name: "config",
                    type: "Json",
                    optional: true
                },
                kbDocumentId: {
                    name: "kbDocumentId",
                    type: "String",
                    optional: true
                },
                faq: {
                    name: "faq",
                    type: "String",
                    optional: true
                },
                faqDocumentId: {
                    name: "faqDocumentId",
                    type: "String",
                    optional: true
                },
                language: {
                    name: "language",
                    type: "String",
                    default: "bg" as FieldDefault
                },
                knowledgeDocs: {
                    name: "knowledgeDocs",
                    type: "AgentKnowledgeDoc",
                    array: true,
                    relation: { opposite: "agent" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                externalAgentId: { type: "String" }
            }
        },
        AgentKnowledgeDoc: {
            name: "AgentKnowledgeDoc",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                agent: {
                    name: "agent",
                    type: "VoiceAgent",
                    relation: { opposite: "knowledgeDocs", fields: ["agentId"], references: ["id"], onDelete: "Cascade" }
                },
                agentId: {
                    name: "agentId",
                    type: "String",
                    foreignKeyFor: [
                        "agent"
                    ] as readonly string[]
                },
                title: {
                    name: "title",
                    type: "String"
                },
                text: {
                    name: "text",
                    type: "String"
                },
                documentId: {
                    name: "documentId",
                    type: "String",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        EmailDelivery: {
            name: "EmailDelivery",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                resendId: {
                    name: "resendId",
                    type: "String",
                    unique: true
                },
                template: {
                    name: "template",
                    type: "String"
                },
                to: {
                    name: "to",
                    type: "String"
                },
                status: {
                    name: "status",
                    type: "String",
                    default: "sent" as FieldDefault
                },
                idempotencyKey: {
                    name: "idempotencyKey",
                    type: "String",
                    optional: true
                },
                lastEventAt: {
                    name: "lastEventAt",
                    type: "DateTime",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                resendId: { type: "String" }
            }
        },
        GroupEvent: {
            name: "GroupEvent",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                name: {
                    name: "name",
                    type: "Json"
                },
                description: {
                    name: "description",
                    type: "Json",
                    optional: true
                },
                active: {
                    name: "active",
                    type: "Boolean",
                    default: true as FieldDefault
                },
                createdById: {
                    name: "createdById",
                    type: "String",
                    foreignKeyFor: [
                        "createdBy"
                    ] as readonly string[]
                },
                createdBy: {
                    name: "createdBy",
                    type: "User",
                    relation: { opposite: "createdGroupEvents", name: "GroupEventCreator", fields: ["createdById"], references: ["id"], onDelete: "Cascade" }
                },
                members: {
                    name: "members",
                    type: "GroupEventMember",
                    array: true,
                    relation: { opposite: "event" }
                },
                slots: {
                    name: "slots",
                    type: "GroupEventSlot",
                    array: true,
                    relation: { opposite: "event" }
                },
                availabilitySources: {
                    name: "availabilitySources",
                    type: "AvailabilitySource",
                    array: true,
                    relation: { opposite: "event", name: "GroupEventSources" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        GroupEventMember: {
            name: "GroupEventMember",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                eventId: {
                    name: "eventId",
                    type: "String",
                    foreignKeyFor: [
                        "event"
                    ] as readonly string[]
                },
                event: {
                    name: "event",
                    type: "GroupEvent",
                    relation: { opposite: "members", fields: ["eventId"], references: ["id"], onDelete: "Cascade" }
                },
                userId: {
                    name: "userId",
                    type: "String",
                    foreignKeyFor: [
                        "user"
                    ] as readonly string[]
                },
                user: {
                    name: "user",
                    type: "User",
                    relation: { opposite: "groupEventMemberships", fields: ["userId"], references: ["id"], onDelete: "Cascade" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                eventId_userId: { eventId: { type: "String" }, userId: { type: "String" } }
            }
        },
        GroupEventSlot: {
            name: "GroupEventSlot",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                eventId: {
                    name: "eventId",
                    type: "String",
                    foreignKeyFor: [
                        "event"
                    ] as readonly string[]
                },
                event: {
                    name: "event",
                    type: "GroupEvent",
                    relation: { opposite: "slots", fields: ["eventId"], references: ["id"], onDelete: "Cascade" }
                },
                startsAt: {
                    name: "startsAt",
                    type: "DateTime"
                },
                endsAt: {
                    name: "endsAt",
                    type: "DateTime"
                },
                capacity: {
                    name: "capacity",
                    type: "Int"
                },
                booked: {
                    name: "booked",
                    type: "Int",
                    default: 0 as FieldDefault
                },
                closed: {
                    name: "closed",
                    type: "Boolean",
                    default: false as FieldDefault
                },
                seriesId: {
                    name: "seriesId",
                    type: "String",
                    optional: true
                },
                enrollments: {
                    name: "enrollments",
                    type: "GroupEventEnrollment",
                    array: true,
                    relation: { opposite: "slot" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        GroupEventEnrollment: {
            name: "GroupEventEnrollment",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                slotId: {
                    name: "slotId",
                    type: "String",
                    foreignKeyFor: [
                        "slot"
                    ] as readonly string[]
                },
                slot: {
                    name: "slot",
                    type: "GroupEventSlot",
                    relation: { opposite: "enrollments", fields: ["slotId"], references: ["id"], onDelete: "Cascade" }
                },
                patientName: {
                    name: "patientName",
                    type: "String"
                },
                patientPhone: {
                    name: "patientPhone",
                    type: "String"
                },
                assignedUserId: {
                    name: "assignedUserId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "assignedUser"
                    ] as readonly string[]
                },
                assignedUser: {
                    name: "assignedUser",
                    type: "User",
                    optional: true,
                    relation: { opposite: "assignedEnrollments", name: "EnrollmentAssignee", fields: ["assignedUserId"], references: ["id"], onDelete: "SetNull" }
                },
                serviceId: {
                    name: "serviceId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "service"
                    ] as readonly string[]
                },
                service: {
                    name: "service",
                    type: "Service",
                    optional: true,
                    relation: { opposite: "enrollments", fields: ["serviceId"], references: ["id"], onDelete: "SetNull" }
                },
                contactId: {
                    name: "contactId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "contact"
                    ] as readonly string[]
                },
                contact: {
                    name: "contact",
                    type: "Contact",
                    optional: true,
                    relation: { opposite: "groupEnrollments", name: "ContactEnrollments", fields: ["contactId"], references: ["id"], onDelete: "SetNull" }
                },
                conversationId: {
                    name: "conversationId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "call"
                    ] as readonly string[]
                },
                call: {
                    name: "call",
                    type: "Call",
                    optional: true,
                    relation: { opposite: "groupEnrollments", name: "CallEnrollments", fields: ["conversationId"], references: ["conversationId"], onDelete: "SetNull" }
                },
                arrivalTime: {
                    name: "arrivalTime",
                    type: "String",
                    optional: true
                },
                status: {
                    name: "status",
                    type: "EnrollmentStatus",
                    default: "ENROLLED" as FieldDefault
                },
                source: {
                    name: "source",
                    type: "String",
                    default: "voice" as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                slotId_patientPhone_patientName: { slotId: { type: "String" }, patientPhone: { type: "String" }, patientName: { type: "String" } }
            }
        },
        Invite: {
            name: "Invite",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                token: {
                    name: "token",
                    type: "String",
                    unique: true
                },
                email: {
                    name: "email",
                    type: "String"
                },
                role: {
                    name: "role",
                    type: "Role",
                    default: "SPECIALIST" as FieldDefault
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                },
                expiresAt: {
                    name: "expiresAt",
                    type: "DateTime"
                },
                visitedAt: {
                    name: "visitedAt",
                    type: "DateTime",
                    optional: true
                },
                usedAt: {
                    name: "usedAt",
                    type: "DateTime",
                    optional: true
                },
                invitedById: {
                    name: "invitedById",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "invitedBy"
                    ] as readonly string[]
                },
                invitedBy: {
                    name: "invitedBy",
                    type: "User",
                    optional: true,
                    relation: { opposite: "invitesSent", name: "invitedBy", fields: ["invitedById"], references: ["id"], onDelete: "SetNull" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                token: { type: "String" }
            }
        }
    } as const;
    typeDefs = {
        Auth: {
            name: "Auth",
            fields: {
                id: {
                    name: "id",
                    type: "String"
                },
                role: {
                    name: "role",
                    type: "Role"
                },
                approved: {
                    name: "approved",
                    type: "Boolean"
                }
            },
            attributes: [
                { name: "@@auth" }
            ] as readonly AttributeApplication[]
        },
        SignUpInput: {
            name: "SignUpInput",
            fields: {
                email: {
                    name: "email",
                    type: "String"
                },
                password: {
                    name: "password",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                }
            }
        },
        LoginInput: {
            name: "LoginInput",
            fields: {
                email: {
                    name: "email",
                    type: "String"
                },
                password: {
                    name: "password",
                    type: "String"
                }
            }
        },
        AdminInviteUserInput: {
            name: "AdminInviteUserInput",
            fields: {
                email: {
                    name: "email",
                    type: "String"
                },
                role: {
                    name: "role",
                    type: "Role",
                    optional: true
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                }
            }
        },
        AdminCreateUserInput: {
            name: "AdminCreateUserInput",
            fields: {
                email: {
                    name: "email",
                    type: "String"
                },
                password: {
                    name: "password",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                },
                role: {
                    name: "role",
                    type: "Role",
                    optional: true
                },
                approved: {
                    name: "approved",
                    type: "Boolean",
                    optional: true
                }
            }
        },
        AcceptInviteInput: {
            name: "AcceptInviteInput",
            fields: {
                token: {
                    name: "token",
                    type: "String"
                },
                password: {
                    name: "password",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                }
            }
        },
        CheckInviteInput: {
            name: "CheckInviteInput",
            fields: {
                token: {
                    name: "token",
                    type: "String"
                }
            }
        },
        CheckInviteResult: {
            name: "CheckInviteResult",
            fields: {
                email: {
                    name: "email",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                },
                role: {
                    name: "role",
                    type: "Role"
                }
            }
        },
        FindSpecialistsInput: {
            name: "FindSpecialistsInput",
            fields: {
                query: {
                    name: "query",
                    type: "String",
                    optional: true
                },
                specialtySlug: {
                    name: "specialtySlug",
                    type: "String",
                    optional: true
                },
                activeOnly: {
                    name: "activeOnly",
                    type: "Boolean",
                    optional: true
                }
            }
        },
        GoogleCalendarConnectInput: {
            name: "GoogleCalendarConnectInput",
            fields: {
                availabilitySourceId: {
                    name: "availabilitySourceId",
                    type: "String"
                }
            }
        },
        GoogleCalendarConnectResult: {
            name: "GoogleCalendarConnectResult",
            fields: {
                consentUrl: {
                    name: "consentUrl",
                    type: "String"
                }
            }
        },
        GoogleCalendarDisconnectInput: {
            name: "GoogleCalendarDisconnectInput",
            fields: {
                availabilitySourceId: {
                    name: "availabilitySourceId",
                    type: "String"
                }
            }
        },
        GoogleCalendarEventsInput: {
            name: "GoogleCalendarEventsInput",
            fields: {
                availabilitySourceId: {
                    name: "availabilitySourceId",
                    type: "String"
                },
                from: {
                    name: "from",
                    type: "String"
                },
                to: {
                    name: "to",
                    type: "String"
                }
            }
        },
        GoogleCalendarEvent: {
            name: "GoogleCalendarEvent",
            fields: {
                id: {
                    name: "id",
                    type: "String"
                },
                summary: {
                    name: "summary",
                    type: "String",
                    optional: true
                },
                reason: {
                    name: "reason",
                    type: "String",
                    optional: true
                },
                description: {
                    name: "description",
                    type: "String",
                    optional: true
                },
                location: {
                    name: "location",
                    type: "String",
                    optional: true
                },
                start: {
                    name: "start",
                    type: "String"
                },
                end: {
                    name: "end",
                    type: "String"
                },
                allDay: {
                    name: "allDay",
                    type: "Boolean"
                },
                status: {
                    name: "status",
                    type: "String",
                    optional: true
                },
                htmlLink: {
                    name: "htmlLink",
                    type: "String",
                    optional: true
                },
                extraCount: {
                    name: "extraCount",
                    type: "Int",
                    optional: true
                },
                source: {
                    name: "source",
                    type: "String",
                    optional: true
                },
                rescheduled: {
                    name: "rescheduled",
                    type: "Boolean",
                    optional: true
                }
            }
        },
        GoogleCalendarEventsResult: {
            name: "GoogleCalendarEventsResult",
            fields: {
                events: {
                    name: "events",
                    type: "GoogleCalendarEvent",
                    array: true
                }
            }
        },
        RemoteContactApptInput: {
            name: "RemoteContactApptInput",
            fields: {
                phone: {
                    name: "phone",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                }
            }
        },
        RemoteContactAppointment: {
            name: "RemoteContactAppointment",
            fields: {
                id: {
                    name: "id",
                    type: "String"
                },
                specialistName: {
                    name: "specialistName",
                    type: "String",
                    optional: true
                },
                patientName: {
                    name: "patientName",
                    type: "String",
                    optional: true
                },
                reason: {
                    name: "reason",
                    type: "String",
                    optional: true
                },
                start: {
                    name: "start",
                    type: "String"
                },
                end: {
                    name: "end",
                    type: "String"
                },
                status: {
                    name: "status",
                    type: "String"
                },
                source: {
                    name: "source",
                    type: "String",
                    optional: true
                }
            }
        },
        RemoteContactApptResult: {
            name: "RemoteContactApptResult",
            fields: {
                appointments: {
                    name: "appointments",
                    type: "RemoteContactAppointment",
                    array: true
                }
            }
        },
        CalendarDayInput: {
            name: "CalendarDayInput",
            fields: {
                from: {
                    name: "from",
                    type: "String"
                },
                to: {
                    name: "to",
                    type: "String"
                }
            }
        },
        CalendarSpecialistDay: {
            name: "CalendarSpecialistDay",
            fields: {
                specialistId: {
                    name: "specialistId",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "String"
                },
                slotMinutes: {
                    name: "slotMinutes",
                    type: "Int"
                },
                provider: {
                    name: "provider",
                    type: "String"
                },
                events: {
                    name: "events",
                    type: "GoogleCalendarEvent",
                    array: true
                }
            }
        },
        CalendarAllResult: {
            name: "CalendarAllResult",
            fields: {
                specialists: {
                    name: "specialists",
                    type: "CalendarSpecialistDay",
                    array: true
                }
            }
        },
        GoogleCalendarsInput: {
            name: "GoogleCalendarsInput",
            fields: {
                availabilitySourceId: {
                    name: "availabilitySourceId",
                    type: "String"
                }
            }
        },
        GoogleCalendarListItem: {
            name: "GoogleCalendarListItem",
            fields: {
                id: {
                    name: "id",
                    type: "String"
                },
                summary: {
                    name: "summary",
                    type: "String"
                },
                primary: {
                    name: "primary",
                    type: "Boolean"
                },
                accessRole: {
                    name: "accessRole",
                    type: "String"
                }
            }
        },
        GoogleCalendarsResult: {
            name: "GoogleCalendarsResult",
            fields: {
                calendars: {
                    name: "calendars",
                    type: "GoogleCalendarListItem",
                    array: true
                }
            }
        },
        ChangePasswordInput: {
            name: "ChangePasswordInput",
            fields: {
                userId: {
                    name: "userId",
                    type: "String"
                },
                newPassword: {
                    name: "newPassword",
                    type: "String"
                },
                currentPassword: {
                    name: "currentPassword",
                    type: "String",
                    optional: true
                }
            }
        },
        AttachCallContactInput: {
            name: "AttachCallContactInput",
            fields: {
                callId: {
                    name: "callId",
                    type: "String"
                },
                contactId: {
                    name: "contactId",
                    type: "String",
                    optional: true
                }
            }
        },
        MergeContactsInput: {
            name: "MergeContactsInput",
            fields: {
                sourceId: {
                    name: "sourceId",
                    type: "String"
                },
                targetId: {
                    name: "targetId",
                    type: "String"
                }
            }
        },
        SetContactSpecialistsInput: {
            name: "SetContactSpecialistsInput",
            fields: {
                contactId: {
                    name: "contactId",
                    type: "String"
                },
                specialistIds: {
                    name: "specialistIds",
                    type: "String",
                    array: true
                }
            }
        },
        CreateAppointmentInput: {
            name: "CreateAppointmentInput",
            fields: {
                contactId: {
                    name: "contactId",
                    type: "String",
                    optional: true
                },
                patientName: {
                    name: "patientName",
                    type: "String",
                    optional: true
                },
                patientPhone: {
                    name: "patientPhone",
                    type: "String",
                    optional: true
                },
                specialistId: {
                    name: "specialistId",
                    type: "String"
                },
                startsAt: {
                    name: "startsAt",
                    type: "String"
                },
                durationMin: {
                    name: "durationMin",
                    type: "Int",
                    optional: true
                },
                reason: {
                    name: "reason",
                    type: "String",
                    optional: true
                },
                note: {
                    name: "note",
                    type: "String",
                    optional: true
                }
            }
        },
        CancelAppointmentInput: {
            name: "CancelAppointmentInput",
            fields: {
                appointmentId: {
                    name: "appointmentId",
                    type: "String"
                },
                patientName: {
                    name: "patientName",
                    type: "String",
                    optional: true
                },
                patientPhone: {
                    name: "patientPhone",
                    type: "String",
                    optional: true
                },
                startsAt: {
                    name: "startsAt",
                    type: "String",
                    optional: true
                },
                specialistId: {
                    name: "specialistId",
                    type: "String",
                    optional: true
                }
            }
        },
        RescheduleAppointmentInput: {
            name: "RescheduleAppointmentInput",
            fields: {
                appointmentId: {
                    name: "appointmentId",
                    type: "String"
                },
                newStartsAt: {
                    name: "newStartsAt",
                    type: "String"
                },
                newSpecialistId: {
                    name: "newSpecialistId",
                    type: "String",
                    optional: true
                },
                fromSpecialistId: {
                    name: "fromSpecialistId",
                    type: "String",
                    optional: true
                },
                patientName: {
                    name: "patientName",
                    type: "String",
                    optional: true
                },
                patientPhone: {
                    name: "patientPhone",
                    type: "String",
                    optional: true
                },
                reason: {
                    name: "reason",
                    type: "String",
                    optional: true
                }
            }
        },
        AppointmentAddGuestInput: {
            name: "AppointmentAddGuestInput",
            fields: {
                appointmentId: {
                    name: "appointmentId",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "String"
                },
                phone: {
                    name: "phone",
                    type: "String",
                    optional: true
                }
            }
        },
        AppointmentRemoveGuestInput: {
            name: "AppointmentRemoveGuestInput",
            fields: {
                appointmentId: {
                    name: "appointmentId",
                    type: "String"
                },
                index: {
                    name: "index",
                    type: "Int"
                }
            }
        },
        AgentIdInput: {
            name: "AgentIdInput",
            fields: {
                id: {
                    name: "id",
                    type: "String"
                }
            }
        },
        AgentFaqInput: {
            name: "AgentFaqInput",
            fields: {
                id: {
                    name: "id",
                    type: "String"
                },
                faq: {
                    name: "faq",
                    type: "String"
                }
            }
        },
        AgentStat: {
            name: "AgentStat",
            fields: {
                externalAgentId: {
                    name: "externalAgentId",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "String"
                },
                calls: {
                    name: "calls",
                    type: "Int"
                },
                durationSec: {
                    name: "durationSec",
                    type: "Int"
                },
                cost: {
                    name: "cost",
                    type: "Float"
                }
            }
        },
        AgentDashboardResult: {
            name: "AgentDashboardResult",
            fields: {
                totalAgents: {
                    name: "totalAgents",
                    type: "Int"
                },
                syncedAgents: {
                    name: "syncedAgents",
                    type: "Int"
                },
                totalCalls: {
                    name: "totalCalls",
                    type: "Int"
                },
                totalDurationSec: {
                    name: "totalDurationSec",
                    type: "Int"
                },
                totalCost: {
                    name: "totalCost",
                    type: "Float"
                },
                avgDurationSec: {
                    name: "avgDurationSec",
                    type: "Int"
                },
                windowDays: {
                    name: "windowDays",
                    type: "Int"
                },
                perAgent: {
                    name: "perAgent",
                    type: "AgentStat",
                    array: true
                }
            }
        },
        AgentCallsInput: {
            name: "AgentCallsInput",
            fields: {
                externalAgentId: {
                    name: "externalAgentId",
                    type: "String"
                }
            }
        },
        AgentFetchInput: {
            name: "AgentFetchInput",
            fields: {
                externalAgentId: {
                    name: "externalAgentId",
                    type: "String"
                }
            }
        },
        AgentCallRow: {
            name: "AgentCallRow",
            fields: {
                id: {
                    name: "id",
                    type: "String"
                },
                startedAt: {
                    name: "startedAt",
                    type: "String",
                    optional: true
                },
                endedAt: {
                    name: "endedAt",
                    type: "String",
                    optional: true
                },
                durationSec: {
                    name: "durationSec",
                    type: "Int"
                },
                cost: {
                    name: "cost",
                    type: "Float"
                },
                status: {
                    name: "status",
                    type: "String",
                    optional: true
                },
                endedReason: {
                    name: "endedReason",
                    type: "String",
                    optional: true
                },
                summary: {
                    name: "summary",
                    type: "String",
                    optional: true
                },
                transcript: {
                    name: "transcript",
                    type: "String",
                    optional: true
                },
                callerName: {
                    name: "callerName",
                    type: "String",
                    optional: true
                },
                callerPhone: {
                    name: "callerPhone",
                    type: "String",
                    optional: true
                }
            }
        },
        AgentCallsResult: {
            name: "AgentCallsResult",
            fields: {
                calls: {
                    name: "calls",
                    type: "AgentCallRow",
                    array: true
                },
                totalCalls: {
                    name: "totalCalls",
                    type: "Int"
                },
                totalDurationSec: {
                    name: "totalDurationSec",
                    type: "Int"
                },
                totalCost: {
                    name: "totalCost",
                    type: "Float"
                }
            }
        },
        InngestRunRow: {
            name: "InngestRunRow",
            fields: {
                runId: {
                    name: "runId",
                    type: "String"
                },
                functionName: {
                    name: "functionName",
                    type: "String",
                    optional: true
                },
                status: {
                    name: "status",
                    type: "String"
                },
                startedAt: {
                    name: "startedAt",
                    type: "String",
                    optional: true
                },
                endedAt: {
                    name: "endedAt",
                    type: "String",
                    optional: true
                },
                output: {
                    name: "output",
                    type: "String",
                    optional: true
                }
            }
        },
        InngestEventRow: {
            name: "InngestEventRow",
            fields: {
                id: {
                    name: "id",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "String"
                },
                receivedAt: {
                    name: "receivedAt",
                    type: "String",
                    optional: true
                },
                dataJson: {
                    name: "dataJson",
                    type: "String"
                },
                runs: {
                    name: "runs",
                    type: "InngestRunRow",
                    array: true
                }
            }
        },
        InngestActivityResult: {
            name: "InngestActivityResult",
            fields: {
                events: {
                    name: "events",
                    type: "InngestEventRow",
                    array: true
                },
                ok: {
                    name: "ok",
                    type: "Boolean"
                },
                error: {
                    name: "error",
                    type: "String",
                    optional: true
                }
            }
        },
        AssistantChatTurn: {
            name: "AssistantChatTurn",
            fields: {
                role: {
                    name: "role",
                    type: "String"
                },
                content: {
                    name: "content",
                    type: "String"
                }
            }
        },
        AssistantAskInput: {
            name: "AssistantAskInput",
            fields: {
                question: {
                    name: "question",
                    type: "String"
                },
                history: {
                    name: "history",
                    type: "AssistantChatTurn",
                    array: true
                },
                language: {
                    name: "language",
                    type: "String"
                },
                path: {
                    name: "path",
                    type: "String",
                    optional: true
                }
            }
        },
        GroupEventIdInput: {
            name: "GroupEventIdInput",
            fields: {
                id: {
                    name: "id",
                    type: "String"
                }
            }
        },
        GroupEventEnrollInput: {
            name: "GroupEventEnrollInput",
            fields: {
                slotId: {
                    name: "slotId",
                    type: "String"
                },
                patientName: {
                    name: "patientName",
                    type: "String"
                },
                patientPhone: {
                    name: "patientPhone",
                    type: "String"
                },
                assignedUserId: {
                    name: "assignedUserId",
                    type: "String",
                    optional: true
                },
                serviceId: {
                    name: "serviceId",
                    type: "String",
                    optional: true
                },
                arrivalTime: {
                    name: "arrivalTime",
                    type: "String",
                    optional: true
                },
                overbook: {
                    name: "overbook",
                    type: "Boolean",
                    optional: true
                }
            }
        },
        GroupEventEnrollmentIdInput: {
            name: "GroupEventEnrollmentIdInput",
            fields: {
                id: {
                    name: "id",
                    type: "String"
                }
            }
        },
        AdminImportInput: {
            name: "AdminImportInput",
            fields: {
                json: {
                    name: "json",
                    type: "String"
                }
            }
        },
        AdminResetDataInput: {
            name: "AdminResetDataInput",
            fields: {
                kind: {
                    name: "kind",
                    type: "String"
                }
            }
        }
    } as const;
    enums = {
        Role: {
            name: "Role",
            values: {
                USER: "USER",
                ADMIN: "ADMIN",
                SPECIALIST: "SPECIALIST",
                SUPERDOC: "SUPERDOC"
            }
        },
        AvailabilityProvider: {
            name: "AvailabilityProvider",
            values: {
                GOOGLE_CALENDAR: "GOOGLE_CALENDAR",
                LOCAL: "LOCAL",
                GROUP_EVENT: "GROUP_EVENT",
                SUPERDOC: "SUPERDOC"
            }
        },
        EnrollmentStatus: {
            name: "EnrollmentStatus",
            values: {
                ENROLLED: "ENROLLED",
                CANCELLED: "CANCELLED"
            }
        },
        AppointmentStatus: {
            name: "AppointmentStatus",
            values: {
                BOOKED: "BOOKED",
                CANCELLED: "CANCELLED"
            }
        },
        CallBookingAction: {
            name: "CallBookingAction",
            values: {
                BOOKED: "BOOKED",
                RESCHEDULED: "RESCHEDULED",
                CANCELLED: "CANCELLED"
            }
        },
        ActivityAction: {
            name: "ActivityAction",
            values: {
                BOOKED: "BOOKED",
                RESCHEDULED: "RESCHEDULED",
                CANCELLED: "CANCELLED",
                LATE: "LATE",
                OTHER: "OTHER"
            }
        },
        ActivityPlatform: {
            name: "ActivityPlatform",
            values: {
                WEB: "WEB",
                PHONE: "PHONE",
                SUPERDOC: "SUPERDOC"
            }
        },
        ContactStatus: {
            name: "ContactStatus",
            values: {
                LEAD: "LEAD",
                ACTIVE: "ACTIVE",
                INACTIVE: "INACTIVE"
            }
        }
    } as const;
    authType = "Auth" as const;
    procedures = {
        signUp: {
            params: {
                input: { name: "input", type: "SignUpInput" }
            },
            returnType: "String",
            mutation: true
        },
        login: {
            params: {
                input: { name: "input", type: "LoginInput" }
            },
            returnType: "String",
            mutation: true
        },
        me: {
            params: {},
            returnType: "User"
        },
        markNotificationsSeen: {
            params: {},
            returnType: "User",
            mutation: true
        },
        deactivateAccount: {
            params: {},
            returnType: "User",
            mutation: true
        },
        findSpecialists: {
            params: {
                input: { name: "input", type: "FindSpecialistsInput" }
            },
            returnType: "Specialist",
            returnArray: true
        },
        adminInviteUser: {
            params: {
                input: { name: "input", type: "AdminInviteUserInput" }
            },
            returnType: "Invite",
            mutation: true
        },
        adminCreateUser: {
            params: {
                input: { name: "input", type: "AdminCreateUserInput" }
            },
            returnType: "User",
            mutation: true
        },
        changePassword: {
            params: {
                input: { name: "input", type: "ChangePasswordInput" }
            },
            returnType: "Boolean",
            mutation: true
        },
        googleCalendarConnect: {
            params: {
                input: { name: "input", type: "GoogleCalendarConnectInput" }
            },
            returnType: "GoogleCalendarConnectResult",
            mutation: true
        },
        googleCalendarDisconnect: {
            params: {
                input: { name: "input", type: "GoogleCalendarDisconnectInput" }
            },
            returnType: "Boolean",
            mutation: true
        },
        googleCalendarEvents: {
            params: {
                input: { name: "input", type: "GoogleCalendarEventsInput" }
            },
            returnType: "GoogleCalendarEventsResult"
        },
        localCalendarPreview: {
            params: {
                input: { name: "input", type: "GoogleCalendarEventsInput" }
            },
            returnType: "GoogleCalendarEventsResult"
        },
        localCalendarPreviewAll: {
            params: {
                input: { name: "input", type: "CalendarDayInput" }
            },
            returnType: "CalendarAllResult"
        },
        remoteContactAppointments: {
            params: {
                input: { name: "input", type: "RemoteContactApptInput" }
            },
            returnType: "RemoteContactApptResult"
        },
        googleCalendars: {
            params: {
                input: { name: "input", type: "GoogleCalendarsInput" }
            },
            returnType: "GoogleCalendarsResult"
        },
        acceptInvite: {
            params: {
                input: { name: "input", type: "AcceptInviteInput" }
            },
            returnType: "String",
            mutation: true
        },
        checkInvite: {
            params: {
                input: { name: "input", type: "CheckInviteInput" }
            },
            returnType: "CheckInviteResult",
            mutation: true
        },
        agentLink: {
            params: {
                input: { name: "input", type: "AgentIdInput" }
            },
            returnType: "VoiceAgent",
            mutation: true
        },
        agentUpdate: {
            params: {
                input: { name: "input", type: "AgentIdInput" }
            },
            returnType: "VoiceAgent",
            mutation: true
        },
        agentDelete: {
            params: {
                input: { name: "input", type: "AgentIdInput" }
            },
            returnType: "VoiceAgent",
            mutation: true
        },
        agentUnlink: {
            params: {
                input: { name: "input", type: "AgentIdInput" }
            },
            returnType: "VoiceAgent",
            mutation: true
        },
        agentFetch: {
            params: {
                input: { name: "input", type: "AgentFetchInput" }
            },
            returnType: "String",
            mutation: true
        },
        agentSyncSpecialists: {
            params: {
                input: { name: "input", type: "AgentIdInput" }
            },
            returnType: "VoiceAgent",
            mutation: true
        },
        agentDeployFaq: {
            params: {
                input: { name: "input", type: "AgentIdInput" }
            },
            returnType: "VoiceAgent",
            mutation: true
        },
        agentSaveFaq: {
            params: {
                input: { name: "input", type: "AgentFaqInput" }
            },
            returnType: "VoiceAgent",
            mutation: true
        },
        agentDashboard: {
            params: {},
            returnType: "AgentDashboardResult"
        },
        agentCalls: {
            params: {
                input: { name: "input", type: "AgentCallsInput" }
            },
            returnType: "AgentCallsResult"
        },
        agentSpecialistRoster: {
            params: {
                input: { name: "input", type: "AgentIdInput" }
            },
            returnType: "String"
        },
        agentSyncKnowledgeDoc: {
            params: {
                input: { name: "input", type: "AgentIdInput" }
            },
            returnType: "AgentKnowledgeDoc",
            mutation: true
        },
        agentDeleteKnowledgeDoc: {
            params: {
                input: { name: "input", type: "AgentIdInput" }
            },
            returnType: "AgentKnowledgeDoc",
            mutation: true
        },
        attachCallContact: {
            params: {
                input: { name: "input", type: "AttachCallContactInput" }
            },
            returnType: "Call",
            mutation: true
        },
        mergeContacts: {
            params: {
                input: { name: "input", type: "MergeContactsInput" }
            },
            returnType: "Contact",
            mutation: true
        },
        setContactSpecialists: {
            params: {
                input: { name: "input", type: "SetContactSpecialistsInput" }
            },
            returnType: "Contact",
            mutation: true
        },
        createAppointment: {
            params: {
                input: { name: "input", type: "CreateAppointmentInput" }
            },
            returnType: "Appointment",
            mutation: true
        },
        cancelAppointment: {
            params: {
                input: { name: "input", type: "CancelAppointmentInput" }
            },
            returnType: "Appointment",
            mutation: true
        },
        rescheduleAppointment: {
            params: {
                input: { name: "input", type: "RescheduleAppointmentInput" }
            },
            returnType: "Appointment",
            mutation: true
        },
        appointmentAddGuest: {
            params: {
                input: { name: "input", type: "AppointmentAddGuestInput" }
            },
            returnType: "Appointment",
            mutation: true
        },
        appointmentRemoveGuest: {
            params: {
                input: { name: "input", type: "AppointmentRemoveGuestInput" }
            },
            returnType: "Appointment",
            mutation: true
        },
        inngestActivity: {
            params: {},
            returnType: "InngestActivityResult"
        },
        assistantAsk: {
            params: {
                input: { name: "input", type: "AssistantAskInput" }
            },
            returnType: "String",
            mutation: true
        },
        groupEventMembers: {
            params: {
                input: { name: "input", type: "GroupEventIdInput" }
            },
            returnType: "String"
        },
        groupEventEnroll: {
            params: {
                input: { name: "input", type: "GroupEventEnrollInput" }
            },
            returnType: "String",
            mutation: true
        },
        groupEventCancelEnrollment: {
            params: {
                input: { name: "input", type: "GroupEventEnrollmentIdInput" }
            },
            returnType: "String",
            mutation: true
        },
        adminExportGroupEvents: {
            params: {},
            returnType: "String"
        },
        adminImportGroupEvents: {
            params: {
                input: { name: "input", type: "AdminImportInput" }
            },
            returnType: "String",
            mutation: true
        },
        adminExportAppointments: {
            params: {},
            returnType: "String"
        },
        adminImportAppointments: {
            params: {
                input: { name: "input", type: "AdminImportInput" }
            },
            returnType: "String",
            mutation: true
        },
        adminResetData: {
            params: {
                input: { name: "input", type: "AdminResetDataInput" }
            },
            returnType: "Int",
            mutation: true
        }
    } as const;
    plugins = {};
}
export const schema = new SchemaType();
